import { useEffect, useState } from "react";

import { Button, Callout, InputGroup, Intent } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { StyledFormGroup } from "@/components/pages_logged_in/program/components/set-components/StyledFormGroup";
import { StyledDialog } from "@/components/pieces/StyledDialog";

interface AddCriterionDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (name: string) => void;
  loading?: boolean;
  errorMessage?: string;
}

export function AddCriterionDialog({
  open,
  onClose,
  onSave,
  loading = false,
  errorMessage = "",
}: AddCriterionDialogProps) {
  const [name, setName] = useState("");

  // Clear form whenever dialog closes
  useEffect(() => {
    if (!open) {
      setName("");
    }
  }, [open]);

  const handleClose = () => {
    onClose();
  };

  const handleSave = () => {
    if (name.trim()) {
      onSave(name.trim());
    }
  };

  return (
    <StyledDialog
      isOpen={open}
      onClose={handleClose}
      lazy={true}
      title={<Box fontSize={18}>Add Evaluation Criterion</Box>}
      width="500px"
    >
      <>
        <Box pt={3} px={24}>
          {errorMessage && (
            <Box mb={2}>
              <Callout icon={null} intent={Intent.DANGER}>
                {errorMessage}
              </Callout>
            </Box>
          )}

          <StyledFormGroup
            label="Criterion Name"
            subLabel="Give this evaluation criterion a clear, descriptive name"
          >
            <InputGroup
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Communication Skills, Problem Solving"
              large
              fill
              autoFocus
              onKeyDown={(e) => {
                if (e.key === "Enter" && name.trim() && !loading) {
                  handleSave();
                }
              }}
            />
          </StyledFormGroup>
        </Box>

        <Flex className="border-border sticky bottom-0 z-10 w-full rounded-b-xl border-t bg-white">
          <Box className="bbs" />
          <Box py={3} px={24}>
            <Button
              intent={Intent.PRIMARY}
              onClick={handleSave}
              loading={loading}
              disabled={!name.trim()}
              large
              style={{ minWidth: 100 }}
            >
              Add Criterion
            </Button>
            <Button onClick={handleClose} large className="ml-2">
              Cancel
            </Button>
          </Box>
        </Flex>
      </>
    </StyledDialog>
  );
}
